export interface FormState {
    OperationType: string;
    ShipmentType: string;
    ShowLogo: boolean;
    ShowPODtext: boolean;
    Signature_Required: boolean;
    Consignee_DisplayText: string;
    Consignee_Visible: boolean;
    ReleasedTo_DisplayText: string;
    ReleasedTo_Visible: boolean;
    DriverName_DisplayText: string;
    DriverName_Visible: boolean;
    ArrayBody: Array<ArrayItem>;
    ArrayTable: Array<ArrayItem>;
    Footer: string;
}

export interface ArrayItem {
    Property: string;
    DisplayText: string;
    Visible: boolean;
}

export const navItems = [
    { id: 1, iconClass: "dripicons-view-thumb", title: "Operation Type Report POD" },
    { id: 2, iconClass: "bx bx-image", title: "Header Report POD" },
    { id: 3, iconClass: "dripicons-checklist", title: "Body Report POD" },
    { id: 4, iconClass: "bx bx-table", title: "Table Report POD" },
    { id: 5, iconClass: "dripicons-document-edit", title: "Footer Report POD" },
    { id: 6, iconClass: "dripicons-preview", title: "Preview Report POD" }
];

export const formHeaderSH = [
    { label: 'Show Logo Client', key: 'ShowLogo', type: 'switch' },
    { label: 'Show Text POD', key: 'ShowPODtext', type: 'switch' },
    { label: 'Consignee Display Text', key: 'Consignee_DisplayText', type: 'input' },
    { label: 'Consignee Visible', key: 'Consignee_Visible', type: 'switch' },
    { label: 'DriverName Display Text', key: 'DriverName_DisplayText', type: 'input' },
    { label: 'DriverName Visible', key: 'DriverName_Visible', type: 'switch' },
    { label: 'Mandatory signature for report generation', key: 'Signature_Required', type: 'switch' }
]
export const formHeaderCR = [
    { label: 'Show Logo Client', key: 'ShowLogo', type: 'switch' },
    { label: 'Show Text POD', key: 'ShowPODtext', type: 'switch' },
    { label: 'ReleasedTo Display Text', key: 'ReleasedTo_DisplayText', type: 'input' },
    { label: 'ReleasedTo Visible', key: 'ReleasedTo_Visible', type: 'switch' },
    { label: 'DriverName Display Text', key: 'DriverName_DisplayText', type: 'input' },
    { label: 'DriverName Visible', key: 'DriverName_Visible', type: 'switch' },
    { label: 'Mandatory signature for report generation', key: 'Signature_Required', type: 'switch' }
]

export const basicFieldsSH = {
    ArrayBody: [
        { Property: 'Number', DisplayText: 'File Number', Visible: false },
        { Property: 'MasterWayBillNumber', DisplayText: 'MasterWayBillNumber', Visible: false },
        { Property: 'CustomerReferenceNumber', DisplayText: 'Customer Reference', Visible: false },
        { Property: 'OriginPort.Name', DisplayText: 'Port of loading', Visible: false },
        { Property: 'DestinationPort.Name', DisplayText: 'Port of Unloading', Visible: false },
        { Property: 'EstimatedArrivalDate', DisplayText: 'Estimated Arrival Date', Visible: false },
        { Property: 'EstimatedDepartureDate', DisplayText: 'Estimated Departure Date', Visible: false },
        { Property: 'customfield[vessel_reference]', DisplayText: 'Vessel Reference', Visible: false },
    ],
    ArrayTable: [
        { Property: 'item[Notes]', DisplayText: 'Mark And Numbers', Visible: false },
        { Property: 'item[Description]', DisplayText: 'Description Of Commodities', Visible: false },
    ]
}

export const basicFieldsCR = {
    ArrayBody: [
        { Property: 'Number', DisplayText: 'File Number', Visible: false },
        { Property: 'PurchaseOrderNumber', DisplayText: 'Purchase Order Number', Visible: false },
        { Property: 'CreatedOn', DisplayText: 'Created On', Visible: false },
    ],
    ArrayTable: [
        { Property: 'item[Notes]', DisplayText: 'Mark And Numbers', Visible: false },
        { Property: 'item[Description]', DisplayText: 'Description Of Commodities', Visible: false },
    ]
}